export const validImageExtensions = ['png', 'gif', 'jpg', 'svg+xml'];

export const validImageMimeTypes = ['image/png', 'image/gif', 'image/jpeg', 'image/svg+xml'];
